module.exports = "/img/_/_/_/assets/images//background_sand.png?356fe66bde1f7509199d591f457b1e95";